import { SET_ALERT_BAR, DISMISS_ALERT_BAR } from './actions';

const initialState = {
  active: false,
  timestamp: '',
  dismissed: false,
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case SET_ALERT_BAR: {
      const { active, timestamp } = action.payload;
      const sameBlock = state.active && active && state.timestamp === timestamp;

      return {
        ...state,
        active,
        timestamp,
        dismissed: sameBlock ? state.dismissed : false,
      };
    }
    case DISMISS_ALERT_BAR:
      return {
        ...state,
        dismissed: true,
      };
    default:
      return state;
  }
}
